<template>
    <div>
        <div class="mb-4 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between">
            <div class="mb-2 mb-md-0">
                <select-date-range v-model="rangeLocal" class="mr-4 d-none d-lg-inline-block" />
                <date-range-picker v-model="rangeLocal" class="w-100" :not-before="fourMonthsAgo" :not-after="new Date()" :shortcuts="false" :clearable="false" />
            </div>

            <div class="ml-0 ml-md-5">
                <div class="d-flex flex-row">
                    <slot name="help" />
                    <select-payment-type v-model="paymentTypeLocal" class="w-100" />
                </div>
            </div>
        </div>

        <div v-if="chartData.rows.length" class="d-flex flex-column flex-lg-row graphs">
            <div class="card" :class="{ 'flex-grow-1': collapsed !== 'sum', 'collapsed': collapsed === 'sum' }">
                <div class="card-body">
                    <div class="graph-controls">
                        <p class="font-weight-bold">Доход (Р)</p>
                        <h1>{{ sum | money }}</h1>
                    </div>

                    <div class="graph flex-grow-1">
                        <ve-line
                            ref="chart_sum"
                            :data="chartData"
                            :extend="collapsed === 'sum' ? settingsCollapsed : {}"
                            :settings="chartSettingsSum"
                            :colors="colorGreen"

                            :legend-visible="false"
                            :grid="collapsed === 'count' ? grid: {}"
                            :y-axis="collapsed === 'count' ? yAxis : {}"

                            :height="collapsed === 'count' ? '100%' : '100%'"
                            :width="collapsed === 'count' ? '100%' : '100.00%'" />
                    </div>

                    <button class="btn btn-link text-nowrap btn-collapse" @click="collapse('count')">Раскрыть график <i class="tlm-icon-chevron-right small" /></button>

                    <button class="btn btn-link text-nowrap btn-collapse-mobile" @click="collapse('count')">
                        <i class="tlm-icon-sort-down small" />
                    </button>
                </div>
            </div>

            <div class="card ml-lg-3 mt-lg-0 mt-3 mt-lg-0 " :class="{ 'flex-grow-1': collapsed !== 'count', 'collapsed': collapsed === 'count' }">
                <div class="card-body">
                    <div class="graph-controls">
                        <p class="font-weight-bold">Продажи (ед.)</p>
                        <h1>{{ count }}</h1>
                    </div>

                    <div class="graph flex-grow-1">
                        <ve-line
                            ref="chart_count"
                            :data="chartData"
                            :extend="collapsed === 'count' ? settingsCollapsed : {}"
                            :settings="chartSettingsCount"
                            :colors="colorBlue"

                            :legend-visible="false"
                            :grid="collapsed === 'sum' ? grid: {}"
                            :y-axis="collapsed === 'sum' ? yAxis : {}"

                            :height="collapsed === 'sum' ? '100%' : '100.00%'"
                            :width="collapsed === 'sum' ? '100%' : '100.00%'" />
                    </div>

                    <button type="button" class="btn btn-link text-nowrap btn-collapse" @click="collapse('sum')"><i class="tlm-icon-chevron-left small" /> Раскрыть график</button>

                    <button class="btn btn-link text-nowrap btn-collapse-mobile" @click="collapse('sum')">
                        <i class="tlm-icon-sort-up small" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VeLine from 'v-charts/lib/line.common'
import DateRangePicker from '@/components/DateRangePicker'
import SelectDateRange from '@/components/SelectDateRange'
import SelectPaymentType from '@/components/SelectPaymentType'

import DateCacheService, { fourMonthsAgo } from '@/services/DateCacheService'

export default {
    components: {
        VeLine,
        DateRangePicker,
        SelectDateRange,
        SelectPaymentType
    },

    props: {
        range: {
            type: Object,
            default: _ => ({ since: null, until: null })
        },

        paymentType: {
            type: String | Number,
            default: 0
        },

        chart: {
            type: Array | Object,
            default: _ => []
        }

    },

    data() {
        return {
            chartSettingsCount: {
                metrics: ['count'], // ['count', 'sum'],
                // dimension: ['day'],
                labelMap: {
                    count: 'Продажи',
                    day: 'Дата'
                }
            },
            chartSettingsSum: {
                metrics: ['sum'], // ['count', 'sum'],
                // dimension: ['day'],
                labelMap: {
                    sum: 'Доход',
                    day: 'Дата'
                }
            },
            grid: {
                show: true,
                top: 10,
                bottom: 0,
                left: 10,
                right: 10,
                borderWidth: 0
            },
            xAxis: {
                // minInterval: 7,
                splitLine: {
                    show: false
                },
                scale: true
            },
            yAxis: {
                splitNumber: 3,
                splitLine: {
                    lineStyle: {
                        type: 'dotted'
                    }
                }
            },

            collapsed: 'sum'
        }
    },

    computed: {
        settingsCollapsed() {
            return {
                title: {
                    show: false
                },

                axisPointer: {
                    show: false
                },

                grid: {
                    show: true,
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    borderWidth: 0,

                    tooltip: {
                        show: false
                    }
                },

                legend: {
                    show: false
                },

                xAxis: {
                    show: false,
                    boundaryGap: false
                },

                yAxis: {
                    show: false
                },

                series: { symbol: 'none' }
            }
        },

        chartData() {
            return {
                columns: ['day', 'count', 'sum'],
                rows: this.chart
            }
        },

        rangeLocal: {
            get() {
                return this.range
            },

            set({ alias, ...range }) {
                alias
                    ? DateCacheService.setAlias('dash', alias)
                    : DateCacheService.set('dash', range)

                this.applyFilter({ ...range, page: 1 })
            }
        },

        paymentTypeLocal: {
            get() {
                return this.paymentType
            },

            set(value) {
                this.$emit('update:payment-type', value)
            }
        },

        count() {
            return this.chart.reduce((count, item) => count + item.count, 0)
        },

        sum() {
            return this.chart.reduce((sum, item) => sum + item.sum, 0)
        },

        fourMonthsAgo
    },

    created() {
        this.colorGreen = ['#2f9468']
        this.colorBlue = ['#0095da']
    },

    methods: {
        collapse(type) {
            this.collapsed = type

            this.$nextTick(_ => {
                this.$refs.chart_sum.echarts.resize()
                this.$refs.chart_count.echarts.resize()
            })
        }
    }
}
</script>
